import { defineComponent as _defineComponent } from 'vue';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton } from "bootstrap-vue";
import { computed } from "vue";
import localize from "@/utils/localization";
import BreadcrumbHeading from "@/components/Common/BreadcrumbHeading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ManageIndexHeader',
    props: {
        header: null,
        message: null,
        createRoute: null
    },
    setup(__props) {
        const props = __props;
        const createUrl = props.createRoute;
        const breadcrumbItems = computed(() => [{ title: "User Preferences", to: "/user" }, { title: props.header }]);
        return { __sfc: true, props, createUrl, breadcrumbItems, faPlus, FontAwesomeIcon, BAlert, BButton, localize, BreadcrumbHeading };
    }
});
